import React from 'react'
import { Container } from './styles'
import { MAX_PROPERTIES_SELECTED } from '~/constants'

interface IProps {
  type: 'warning' | 'info'
}

export const MaxPropertiesSelectedMessage = ({ type }: IProps): JSX.Element => {
  return (
    <Container type={type}>
      {type === 'warning'
        ? `Só é possível selecionar até ${MAX_PROPERTIES_SELECTED} propriedades para comparação.`
        : `Selecione até ${MAX_PROPERTIES_SELECTED} propriedades para gerar um gráfico comparativo`}
    </Container>
  )
}
